import { render, staticRenderFns } from "./EditPharmacistAppointment.vue?vue&type=template&id=0fbb9276&"
import script from "./EditPharmacistAppointment.vue?vue&type=script&lang=js&"
export * from "./EditPharmacistAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports